import { Tooltip, useTheme } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { IconType } from 'common-types';
import { FunctionComponent, memo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const NavItem: FunctionComponent<React.PropsWithChildren<NavItemProps>> = ({
  href,
  icon: Icon,
  title,
  disabled,
  drawerOpen,
  active,
}) => {
  const theme = useTheme();

  return (
    <Tooltip arrow placement='right' title={drawerOpen ? '' : `${title} Page`}>
      <ListItem sx={{ height: 40 }} disablePadding disableGutters>
        <ListItemButton
          disabled={disabled}
          sx={{ py: 0 }}
          component={RouterLink}
          to={href}>
          <ListItemIcon sx={{ minWidth: 35 }}>
            <Icon
              style={{
                width: 18,
                height: 18,
                color: active ? theme.palette.primary.main : 'inherit',
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={title}
            sx={{
              color: active ? theme.palette.primary.main : 'inherit',
              opacity: drawerOpen ? 1 : 0,
              transition: theme.transitions.create('opacity', {
                duration: theme.transitions.duration.standard,
              }),
            }}
          />
        </ListItemButton>
      </ListItem>
    </Tooltip>
  );
};

interface NavItemProps {
  href: string;
  icon: IconType;
  title: string;
  disabled?: boolean;
  drawerOpen: boolean;
  active: boolean;
}

export default memo(NavItem);
